export const PARTNER_NAMES = {
  PDQ: 'PDQ',
  QSR: "QSRSoft (McDonald's)",
  SERVANT: 'Servant Systems',
  RASI: 'RASI',
  RIPPLING: 'Rippling',
  UKG: 'UKG',
}
